import * as React from 'react';
import { TopModel } from '@goldwasserexchange/react-topmodel';
import { RippleEffectBase, } from './components';
export var rippleEffectDefaultTopModelsObject = {
    RippleEffectBase: (React.createElement(TopModel, { name: "RippleEffectBase" }, RippleEffectBase)),
};
